export const activeChangeSelector = (state) => {
    const {selectedValue, layers, selected, changeFeatures} = state.changes
    return {selectedValue, activeLayerId: layers[selected] && layers[selected].id, changeType: 'ndvi', changeFeatures, selected}

}




// WEBPACK FOOTER //
// ./src/redux/changesSelectors.js